// extracted by mini-css-extract-plugin
module.exports = {"help":"HelpUpdateBatchCsv__help--2P8lH","image":"HelpUpdateBatchCsv__image--3eS7X"};